import { OnInit, Component, EventEmitter, Output, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MainState } from "@app/store/state";
import { DeviceService } from "@core/services/device.service";
import { MarketplaceFilterModel } from "@features/equipment/components/marketplace-filter/marketplace-filter.component";
import { Store } from "@ngrx/store";
import { BaseComponentDirective } from "@shared/components/base-component.directive";

@Component({
  selector: "astrobin-marketplace-search-bar",
  templateUrl: "./marketplace-search-bar.component.html",
  styleUrls: ["./marketplace-search-bar.component.scss"]
})
export class MarketplaceSearchBarComponent extends BaseComponentDirective implements OnInit {
  @Output()
  search = new EventEmitter<MarketplaceFilterModel>();

  @ViewChild("searchInput")
  searchInput: ElementRef<HTMLInputElement>;

  query: string;

  constructor(
    public readonly store$: Store<MainState>,
    public readonly activatedRoute: ActivatedRoute,
    public readonly deviceService: DeviceService
  ) {
    super(store$);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.activatedRoute.queryParams.subscribe(params => {
      this.query = params.query || "";
    });
  }

  onSubmit(event: Event) {
    event.preventDefault();

    if (this.deviceService.isTouchEnabled() && !this.deviceService.isHybridPC()) {
      this.searchInput?.nativeElement.blur();
    }

    this.search.emit({
      query: this.query
    });
  }
}
